/**
 * Create store file
 *
 * @package    src/shared
 * @author     YingTuring <ying@turing.com>
 * @copyright  2018 Turing Company
 * @license    Turing License
 * @version    2.0
 * @link       https://turing.ly
 */
import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducers from '../reducers';
import thunkMiddleware from 'redux-thunk';
import sentryMiddleware from '../dv2_temporary_solution/services/Sentry';
//import logger from 'redux-logger';

/**
 * Persistence config
 */
const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ['userObject', 'acc_recording'],
  transforms: [createTransform(
    (inboundState, key) => {
      // if not authenticated disable redux-persist for profile and tests
      if (!window.localStorage.authenticated && ['profile', 'tests'].includes(key)) {
        return {};
      }
      return inboundState;
    },
    (outboundState, key) => outboundState
  )]
}

/**
 * Replace redux combine reducers
 */
const persistedReducer = persistReducer(persistConfig, reducers)
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const middleware = [thunkMiddleware, sentryMiddleware()];
/**
 * Create redux store
 */
export const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(...middleware  /*, logger*/))
)

/**
 * Creates a persistor for a given store.
 */
export const persistor = persistStore(store)